import BLOCKS from 'shared/constants/blocks'

Object.freeze(BLOCKS)

export default BLOCKS
